export const MAX_FILES = 3;
export const MAX_FILE_SIZE_MB = 100;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const FILE_SIZE_LIMITS = {
    'application/pdf': 100,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 100,
    'application/msword': 100,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 100,
    'application/vnd.ms-excel': 100,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 100,
    'application/vnd.ms-powerpoint': 100,
    'image/png': 100,
    'image/jpeg': 100,
    'image/gif': 100,
    'image/webp': 100,
    'image/bmp': 100,
};

export const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-powerpoint',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/bmp',
];

export const ACCEPT_EXTENSIONS =
    '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.webp,.bmp';
